<mat-chip
	selected
	[ngClass]="cssClass"
>
	<span>C-ITS:&nbsp;</span>
	{{ displayTextTranslation | translate }}
</mat-chip>
